import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { APIService } from '../../services/api/api.service';
import * as ProductActions from './product.actions';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class ProductEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly notification: NzNotificationService,
    private readonly api: APIService
  ) {}

  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.loadProducts),
      exhaustMap(action =>
        this.api.getProductsInCategory(action.category).pipe(
          map(products => ProductActions.loadProductsSuccess({ products })),
          catchError(error => {
            this.notification.error(
              'Error',
              'There was an error loading products.'
            );
            return of(ProductActions.loadProductsFailure({ error }));
          })
        )
      )
    )
  );

  loadCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.loadCategories),
      exhaustMap(() =>
        this.api.getCategories().pipe(
          map(categories =>
            ProductActions.loadCategoriesSuccess({ categories })
          ),
          catchError(error => {
            this.notification.error(
              'Error',
              'There was an error loading categories.'
            );
            return of(ProductActions.loadCategoriesFailure({ error }));
          })
        )
      )
    )
  );

  getProductV2$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.getProductV2),
      exhaustMap(action =>
        this.api.getProductV2(action.id).pipe(
          map(product => ProductActions.getProductV2Success({ product })),
          catchError(error => {
            this.notification.error(
              'Error',
              'There was an error loading product details.'
            );
            return of(ProductActions.getProductV2Failure({ error }));
          })
        )
      )
    )
  );

  loadProductVariants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.loadProductVariants),
      exhaustMap(action =>
        this.api.getProductVariants(action.productId).pipe(
          map(variants =>
            ProductActions.loadProductVariantsSuccess({ variants })
          ),
          catchError(error => {
            this.notification.error(
              'Error',
              'There was an error loading product variants.'
            );
            return of(ProductActions.loadProductVariantsFailure({ error }));
          })
        )
      )
    )
  );
}
